/** FAQ, Support, and Advertising page copy (Hungarian). */
export const pagesMessagesHu = {
  faq: {
    pageTitle: "Gyakran Ismételt Kérdések",
    pageSubtitle: "Találjon választ a WasOK-kal kapcsolatos gyakori kérdésekre",
    seoTitle: "GYIK — WasOK",
    seoDescription:
      "Válaszok a WasOK-kal, a termékbeolvasással, az adatvédelemmel és az értékelésekkel kapcsolatos gyakori kérdésekre.",
    items: [
      {
        question: "Hogyan működik a WasOK?",
        answer:
          "A WasOK segít emlékezni arra, mely termékeket kedvelte vagy nem, a vonalkódok beolvasásával, valamint az értékelések és jegyzetek mentésével. Egyszerűen olvassa be egy termék vonalkódját, értékelje, adjon hozzá jegyzeteket, és amikor legközelebb beolvassa ugyanazt a terméket, azonnal látni fogja a korábbi értékelését.",
      },
      {
        question: "A felhőben tárolják az adataimat?",
        answer:
          "Nem! Minden adata helyben, az eszközén tárolódik. Az információit nem szinkronizáljuk a felhővel, ami azt jelenti, hogy vásárlási előzményei és termékekkel kapcsolatos véleményei teljesen privátak maradnak. Ez azonban azt is jelenti, hogy készítsen biztonsági mentést az eszközéről, ha meg szeretné őrizni az adatait.",
      },
      {
        question: "Szükségem van internetkapcsolatra a WasOK használatához?",
        answer:
          "Nem, a WasOK teljesen offline is működik. Mivel minden adata helyben, az eszközén tárolódik, internetkapcsolat nélkül is beolvashat termékeket, adhat hozzá értékeléseket és tekintheti meg az előzményeit.",
      },
      {
        question: "Bármilyen típusú termékhez használhatom a WasOK-ot?",
        answer:
          "Igen! A WasOK bármilyen termékkel működik, amelyen van vonalkód. Legyen szó élelmiszerről, kozmetikumról, háztartási cikkről, elektronikáról vagy bármi másról, amin vonalkód van, beolvashatja és elmentheti a véleményét.",
      },
      {
        question: "Hogyan olvasok be egy vonalkódot?",
        answer:
          "Egyszerűen nyissa meg a WasOK alkalmazást, és koppintson a beolvasás gombra. Irányítsa a kameráját a termék vonalkódjára, és az alkalmazás automatikusan felismeri és beolvassa azt. A legjobb eredmény érdekében győződjön meg róla, hogy a vonalkód jól megvilágított és éles.",
      },
      {
        question: "Adhatok fotókat a termékértékeléseimhez?",
        answer:
          "Igen! Bármely termékértékeléshez csatolhat fotókat. Ez különösen hasznos a csomagolási részletek, összetevőlisták vagy bármilyen más vizuális információ megjegyzéséhez, amely segíthet emlékezni, miért kedvelte vagy nem kedvelte a terméket.",
      },
      {
        question: "Milyen információkat menthetek a termékekről?",
        answer:
          "Menthet értékeléseket (1-5 csillag), szöveges jegyzeteket, fotókat, a fizetett árat, a vásárlás helyét és egyedi kategóriákat. Ez az átfogó információ segít megalapozott döntéseket hozni a vásárláskor.",
      },
      {
        question: "Készíthetek bevásárlólistákat?",
        answer:
          "Igen! A WasOK lehetővé teszi, hogy bevásárlólistákat készítsen a már értékelt termékekből. Ez megkönnyíti, hogy emlékezzen, mely termékeket szerette és szeretné újra megvásárolni.",
      },
      {
        question: "Hogyan rendszerezhetem a termékeimet?",
        answer:
          "A termékeket egyedi kategóriák segítségével rendszerezheti. Létrehozhat például olyan kategóriákat, mint „Nassolnivalók”, „Kávé”, „Bőrápolás” vagy „Tisztítószerek”. Ez megkönnyíti az értékelések típus szerinti böngészését.",
      },
      {
        question: "Ingyenes a WasOK használata?",
        answer:
          "Igen, a WasOK letöltése és használata teljesen ingyenes. Nincsenek alkalmazáson belüli vásárlások, előfizetések vagy rejtett díjak. Hisszük, hogy mindenkinek hozzá kell férnie egy privát módszerhez a termékpreferenciáik megjegyzésére.",
      },
      {
        question: "Akadálymentes a WasOK?",
        answer:
          "A WasOK-ot úgy tervezték, hogy minél többen tudják használni. Az alkalmazás olyan akadálymentesítési funkciókat tartalmaz, mint a képernyőolvasó-támogatás, a méretezhető szöveg és az opcionális nagy kontrasztú mód.",
      },
      {
        question: "Mi történik, ha eltávolítom az alkalmazást?",
        answer:
          "Mivel minden adat helyben, az eszközén tárolódik, az alkalmazás eltávolítása törli az összes termékértékelését, jegyzetét és bevásárlólistáját. Az eltávolítás előtt exportálja adatait, ha meg szeretné őrizni a biztonsági mentést.",
      },
      {
        question: "Exportálhatom az adataimat?",
        answer:
          "Igen, a WasOK lehetővé teszi az adatok exportálását biztonsági mentés céljából. Az összes értékelését exportálhatja egy fájlba, amelyet az eszközén vagy a választott felhőtárhelyen menthet el.",
      },
      {
        question: "Nyomon követi a WasOK a tartózkodási helyemet?",
        answer:
          "Nem, a WasOK nem követi a tartózkodási helyét. Bár manuálisan megadhatja annak az üzletnek a nevét, ahol a terméket vásárolta, az alkalmazás nem használ GPS-t vagy helymeghatározó szolgáltatásokat.",
      },
      {
        question: "Használhatom a WasOK-ot több eszközön?",
        answer:
          "Jelenleg a WasOK nem szinkronizál az eszközök között, mivel minden adat helyben tárolódik. Minden eszköznek saját, külön adatbázisa lesz a termékekről és értékelésekről.",
      },
      {
        question: "Mi van, ha egy vonalkód nem olvasható be?",
        answer:
          "Ha egy vonalkód nem olvasható be, győződjön meg róla, hogy jól megvilágított és éles. Kipróbálhatja a kamera lencséjének megtisztítását is. Ha a vonalkód sérült vagy nem tiszta, lehetőség van a vonalkód számának kézi megadására.",
      },
    ],
    cta: {
      heading: "Még mindig van kérdése?",
      body: "Vegye fel a kapcsolatot ügyfélszolgálati csapatunkkal — szívesen segítünk.",
      button: "Kapcsolatfelvétel az ügyfélszolgálattal",
    },
  },
  support: {
    pageTitle: "Ügyfélszolgálat",
    seoTitle: "Ügyfélszolgálat — WasOK",
    seoDescription:
      "Segítségre van szüksége a WasOK-kal kapcsolatban: kapcsolatfelvétel, hibabejelentés és visszajelzés küldése.",
    getHelp: {
      title: "Segítségkérés",
      body: "Azért vagyunk itt, hogy a lehető legtöbbet hozza ki a WasOK-ból. Ha problémái vannak vagy kérdései merülnek fel, számos erőforrás áll rendelkezésére.",
    },
    faq: {
      title: "Gyakran Ismételt Kérdések",
      body: "Mielőtt felvenné velünk a kapcsolatot, nézze meg a GYIK részt, ahol megválaszoljuk a WasOK-kal kapcsolatos leggyakoribb kérdéseket. Itt részletes információkat talál az alkalmazás működéséről, az adatvédelemről, az adattárolásról és egyebekről.",
    },
    contact: {
      title: "Kapcsolatfelvétel az ügyfélszolgálattal",
      body: "Ha nem találja a keresett választ, ügyfélszolgálati csapatunk készen áll a segítségre. Elérhet minket a következő címen:",
      emailLabel: "E-mail:",
      responseTime: "Válaszunkat általában 24-48 órán belül küldjük",
    },
    bugs: {
      title: "Hibabejelentés",
      body: "Hibát talált? Örülünk, ha segít jobbá tenni a WasOK-ot. Hiba bejelentésekor kérjük, adja meg a következőket:",
      items: [
        "A probléma részletes leírása",
        "A probléma reprodukálásának lépései",
        "Az Ön eszközmodellje és Android verziója",
        "Képernyőképek vagy képernyőfelvételek, ha lehetséges",
      ],
      sendPrefix: "Küldje a hibabejelentéseket a következő címre:",
    },
    featureRequests: {
      title: "Funkciókérések",
      bodyBefore: "Ötlete van egy új funkcióhoz? Szívesen halljuk! Küldje javaslatait a",
      bodyAfter:
        " címre. Bár nem tudunk minden kérést megvalósítani, alaposan mérlegelünk minden visszajelzést a jövőbeli frissítések tervezésekor.",
    },
    knownIssues: {
      title: "Ismert Problémák",
      body: "Jelenleg tudunk a következő problémákról, és dolgozunk a javításukon:",
      items: [
        "Egyes vonalkódok gyenge fényviszonyok között nem olvashatók be — próbálja meg zseblámpával",
        "Nagyon hosszú termékjegyzetek mentése régebbi eszközökön eltarthat egy ideig",
        "A kép miniatűrök pixelesnek tűnhetnek nagy felbontású kijelzőkön",
      ],
    },
    appUpdates: {
      title: "Alkalmazásfrissítések",
      body: "Rendszeresen adunk ki frissítéseket új funkciókkal, fejlesztésekkel és hibajavításokkal. Gondoskodjon róla, hogy a WasOK-ot a Google Play Store-on keresztül naprakészen tartsa a legújabb fejlesztések eléréséhez.",
    },
    community: {
      title: "Közösség",
      body: "Csatlakozzon azon felhasználóink közösségéhez, akik okosabb vásárlási döntéseket hoznak a WasOK segítségével. Osszon meg tippeket, tegyen fel kérdéseket, és lépjen kapcsolatba más felhasználókkal közösségi csatornáinkon.",
    },
    emergency: {
      title: "Sürgősségi Támogatás",
      body: 'Ha olyan kritikus problémát tapasztal, amely megakadályozza az alkalmazás használatában, kérjük, jelölje meg e-mailjét „SÜRGŐS”-ként a tárgyban, és elsőbbséget adunk a kérésének.',
    },
    cta: {
      heading: "Még mindig segítségre van szüksége?",
      body: "Ügyfélszolgálati csapatunk itt van Önért. Ne habozzon felvenni velünk a kapcsolatot bármilyen kérdéssel vagy aggállyal.",
      button: "E-mail az ügyfélszolgálatnak",
    },
  },
  advertising: {
    pageTitle: "Hirdetés és Monetizáció",
    seoTitle: "Hirdetés — WasOK",
    seoDescription: "Hogyan viszonyul a WasOK a hirdetésekhez és a monetizációhoz.",
    approach: {
      title: "Megközelítésünk",
      body: "A WasOK-nál hisszük, hogy a vásárlási szokásai és a termékekkel kapcsolatos véleményei privátak és személyesek. Üzleti modellünk ezt az alapértéket tükrözi.",
    },
    noAds: {
      title: "Nincsenek Hirdetések",
      body: "A WasOK nem jelenít meg hirdetéseket. Soha nem fogunk olyan hirdetéseket mutatni, amelyek az Ön által beolvasott termékeken, adott értékeléseken vagy bármely más, az alkalmazásban létrehozott adaton alapulnak. A WasOK-kal szerzett élménye teljesen hirdetésmentes.",
    },
    noDataSelling: {
      title: "Nincs Adateladás",
      body: "Nem adjuk el, béreljük vagy osztjuk meg az adatait hirdetőkkel, adatbrókerekkel vagy más harmadik felekkel. Mivel minden adata helyben, az eszközén tárolódik, mi magunk sem férünk hozzá. Termékértékelései, bevásárlólistái és jegyzetei kizárólag az Önéi.",
    },
    noTracking: {
      title: "Nincs Nyomon Követés",
      body: "A WasOK nem használ nyomkövető pixeleket, elemzési szolgáltatásokat vagy bármilyen más technológiát, amely figyelemmel kíséri a viselkedését vagy megosztja az információkat harmadik felekkel. Nem követjük nyomon, milyen termékeket olvas be, milyen üzletekben vásárol, vagy hogyan használja az alkalmazást.",
    },
    sustainability: {
      title: "Hogyan Maradunk Fenntarthatók",
      body: "Kíváncsi lehet, hogyan tartjuk ingyenesen a WasOK-ot hirdetések vagy adateladás nélkül. Megközelítésünk egyszerű:",
      items: [
        {
          label: "Ingyenes és Nyílt:",
          text: "A WasOK mindenki számára ingyenesen használható, prémium szintek vagy fizetőfalak nélkül",
        },
        {
          label: "Karcsú Működés:",
          text: "Alacsonyan tartjuk a költségeinket hatékony, adatvédelem-központú szoftverek fejlesztésével",
        },
        {
          label: "Opcionális Adományok:",
          text: "Azok a felhasználók, akik szeretik a WasOK-ot, önkéntes adományokkal támogathatnak minket",
        },
        {
          label: "Nyílt Forráskód:",
          text: "Tanácsadási vagy egyedi fejlesztési szolgáltatásokat kínálhatunk szervezetek számára",
        },
      ],
    },
    noAffiliate: {
      title: "Nincsenek Partnerlinkek",
      body: "A WasOK nem használ partnerlinkeket, és nem kap jutalékot kiskereskedőktől. Amikor beolvas egy terméket, nem irányítjuk sehova a megvásárlásához. Az alkalmazás kizárólag a személyes nyilvántartás és döntéshozatal céljából szolgál.",
    },
    noPromotions: {
      title: "Nincsenek Termékpromóciók",
      body: "Nem fogadunk el fizetést márkáktól vagy gyártóktól termékeik promóciójáért. A WasOK soha nem javasol termékeket, nem emel ki bizonyos márkákat, és nem befolyásolja az értékeléseit semmilyen módon. A véleménye kizárólag az Öné.",
    },
    partnerships: {
      title: "Harmadik Fél Partnerségek",
      body: "A WasOK nem működik együtt marketingcégekkel, adataggregátorokkal vagy hirdetési hálózatokkal. Függetlenül működünk, és mindenek felett az Ön adatvédelmét helyezzük előtérbe.",
    },
    future: {
      title: "Jövőbeli Tervek",
      body: "Elkötelezettek vagyunk amellett, hogy a WasOK hirdetésmentes és adatvédelem-központú maradjon. Ha valaha is fenntartható üzleti modellt kellene bevezetnünk a jövőben, akkor:",
      items: [
        "Minden változásról jóval előre értesítünk",
        "Soha nem kötünk kompromisszumot az adatvédelem vagy az adatbiztonság terén",
        "Mindig biztosítunk módot az alkalmazás nyomon követés vagy hirdetések nélküli használatára",
        "Meghallgatjuk a felhasználói visszajelzéseket és aggályokat",
      ],
    },
    supporting: {
      title: "A WasOK Támogatása",
      body: "Ha szereti a WasOK-ot, és szeretné támogatni az adatvédelem-központú vásárlási emlékezet küldetésünket, a következőket teheti:",
      items: [
        "Meséljen az alkalmazásról barátainak és családjának",
        "Hagyjon pozitív értékelést a Google Play Store-ban",
        "Ossza meg velünk visszajelzéseit és javaslatait",
        "Fontolja meg egy önkéntes adomány felajánlását (ha elérhető)",
      ],
    },
    cta: {
      heading: "Kérdése van a szabályzatainkkal kapcsolatban?",
      body: "Átláthatóan működünk a WasOK üzemeltetésével kapcsolatban. Ha bármilyen kérdése van az adatvédelemhez, monetizációhoz vagy fenntarthatósághoz való hozzáállásunkról, kérjük, vegye fel velünk a kapcsolatot.",
      button: "Vegye Fel Velünk a Kapcsolatot",
    },
  },
};
